import axios from "axios";
import { getToken } from "../../auth/authService";

const BASE = process.env.REACT_APP_BASE_URL;
const auth = () => ({ Authorization: `Bearer ${getToken()}` });
const handle = (p) =>
  p
    .then((r) => ({ status: r.status, data: r.data }))
    .catch((e) => ({ status: e.response?.status || 500, message: e.response?.data?.message || "Request failed" }));

// ── Content Blocks ────────────────────────────────────────────────────────────
export const fetchContentBlocks = (params) =>
  handle(axios.get(`${BASE}/admin/content-blocks`, { headers: auth(), params }));
export const fetchContentBlockById = (id) =>
  handle(axios.get(`${BASE}/admin/content-blocks/${id}`, { headers: auth() }));
export const createContentBlock = (data) =>
  handle(axios.post(`${BASE}/admin/content-blocks`, data, { headers: auth() }));
export const updateContentBlock = (id, data) =>
  handle(axios.put(`${BASE}/admin/content-blocks/${id}`, data, { headers: auth() }));
export const deleteContentBlock = (id) =>
  handle(axios.delete(`${BASE}/admin/content-blocks/${id}`, { headers: auth() }));

// ── Practice Sets ─────────────────────────────────────────────────────────────
export const fetchPracticeSets = (params) =>
  handle(axios.get(`${BASE}/admin/practice-sets`, { headers: auth(), params }));
export const fetchPracticeSetById = (id) =>
  handle(axios.get(`${BASE}/admin/practice-sets/${id}`, { headers: auth() }));
export const createPracticeSet = (data) =>
  handle(axios.post(`${BASE}/admin/practice-sets`, data, { headers: auth() }));
export const updatePracticeSet = (id, data) =>
  handle(axios.put(`${BASE}/admin/practice-sets/${id}`, data, { headers: auth() }));
export const deletePracticeSet = (id) =>
  handle(axios.delete(`${BASE}/admin/practice-sets/${id}`, { headers: auth() }));

// ── Quizzes ───────────────────────────────────────────────────────────────────
export const fetchQuizzes = (params) =>
  handle(axios.get(`${BASE}/admin/quizzes`, { headers: auth(), params }));
export const fetchQuizById = (id) =>
  handle(axios.get(`${BASE}/admin/quizzes/${id}`, { headers: auth() }));
export const createQuiz = (data) =>
  handle(axios.post(`${BASE}/admin/quizzes`, data, { headers: auth() }));
export const updateQuiz = (id, data) =>
  handle(axios.put(`${BASE}/admin/quizzes/${id}`, data, { headers: auth() }));
export const deleteQuiz = (id) =>
  handle(axios.delete(`${BASE}/admin/quizzes/${id}`, { headers: auth() }));

// ── Content Categories ───────────────────────────────────────────────────────
export const fetchPublicContentCategories = () =>
  handle(axios.get(`${BASE}/public/content-categories`));
export const fetchAdminContentCategories = () =>
  handle(axios.get(`${BASE}/admin/content-categories`, { headers: auth() }));
export const createContentCategory = (data) =>
  handle(axios.post(`${BASE}/admin/content-categories`, data, { headers: auth() }));
export const updateContentCategory = (id, data) =>
  handle(axios.put(`${BASE}/admin/content-categories/${id}`, data, { headers: auth() }));
export const deleteContentCategory = (id) =>
  handle(axios.delete(`${BASE}/admin/content-categories/${id}`, { headers: auth() }));

// ── Topic Links ───────────────────────────────────────────────────────────────
export const fetchTopicLinks = (topicType, topicId) =>
  handle(axios.get(`${BASE}/admin/topic-links`, { headers: auth(), params: { topicType, topicId } }));
export const createTopicLink = (data) =>
  handle(axios.post(`${BASE}/admin/topic-links`, data, { headers: auth() }));
export const deleteTopicLink = (linkId) =>
  handle(axios.delete(`${BASE}/admin/topic-links/${linkId}`, { headers: auth() }));
